import React from 'react'

import PartnerBonusAccrualView from 'pages/parts/PartnerBonusAccrualView'

function Index() {
	return (
		<PartnerBonusAccrualView
			accrualApiPath="/partner/bonus-accrual"
			partnersHelperPath="/partner/helper/partners"
			hintKey="partner_bonus_accrual_hint"
			partnerFilterPlaceholderKey="partner_bonus_accrual_all_partners"
			showBusinessProfitComparison={false}
		/>
	)
}

export default Index
